import { createApp } from 'vue';
import Cr2ToAvifConverter from '../Components/Cr2ToAvifConverter.vue';

const root = document.getElementById('cr2-to-avif-converter');
if (root) {
  createApp(Cr2ToAvifConverter).mount('#cr2-to-avif-converter');
}
